import { z } from 'zod';

import { BlockValueNumberSchema } from '../base/blockValueNumberSchema.js';

export enum GetFormSetType {
  UserDefined = 'userDefined',
  AutomaticallyApplied = 'automaticallyApplied',
  AutomaticallyAppliedAll = 'automaticallyAppliedAll',
}

export enum FormSetSearchScope {
  CurrentPractice = 'CurrentPractice',
  AcrossEhrSystem = 'AcrossEhrSystem',
}

export const getFormSetLimitNumberSchema = z.number().int().min(1).max(50);

export const getFormSetBlockAutomaticallyAppliedAllLimitSchema = BlockValueNumberSchema({
  numberValidationSchema: getFormSetLimitNumberSchema,
})
  .optional()
  .default('10');

const baseConfig = z.object({
  formTemplateId: z.string().optional(),
  primitive: z.string().optional(),
});

export const GetFormSetBlockConfigSchema = z.discriminatedUnion('type', [
  baseConfig.extend({
    type: z.literal(GetFormSetType.UserDefined),
    formSetId: z.string(),
  }),
  baseConfig.extend({
    type: z.literal(GetFormSetType.AutomaticallyApplied),
    searchScope: z.enum(FormSetSearchScope).optional().default(FormSetSearchScope.CurrentPractice),
  }),
  baseConfig.extend({
    type: z.literal(GetFormSetType.AutomaticallyAppliedAll),
    searchScope: z.enum(FormSetSearchScope).optional().default(FormSetSearchScope.CurrentPractice),
    before: z.string().optional(),
    after: z.string().optional(),
    limit: getFormSetBlockAutomaticallyAppliedAllLimitSchema,
  }),
]);

export type GetFormSetBlockConfig = z.infer<typeof GetFormSetBlockConfigSchema>;
